module.exports = __webpack_public_path__ + "img/logo.abad9815.jpg";